import { DataExplorerDisplayCard } from './DataExplorerDisplayCard';
import type { DataExplorerDisplayListItemProps } from './types';
import { cn } from './utils';

export function DataExplorerDisplayListItem<TSource = unknown>({
  className,
  classNames,
  ...props
}: DataExplorerDisplayListItemProps<TSource>) {
  return (
    <DataExplorerDisplayCard
      {...props}
      className={cn('rounded-md', className)}
      classNames={{
        ...classNames,
        root: cn('flex-row items-stretch', classNames?.root),
        media: cn('w-28 shrink-0', classNames?.media),
        header: cn('flex min-w-0 flex-1 items-center p-3', classNames?.header),
        body: cn('px-3 pb-3', classNames?.body),
      }}
    />
  );
}
